import { Col, Row } from '@opendoor/bricks-next';
import type { BoxProps } from '@opendoor/bricks-next';

export const gridStyles = {
  colSpan12: 'span 12 / span 12',
};

interface GridProps extends BoxProps {
  horizontalMargin?: boolean;
  verticalMargin?: boolean;
  children: React.ReactNode;
}

function Grid({
  backgroundColor,
  children,
  verticalMargin = false,
  horizontalMargin = true,
  maxWidth = '$1440x' as BoxProps['maxWidth'],
  mr,
  ml,
  ...props
}: GridProps) {
  return (
    <Row width="100%" justifyContent="center" {...props} backgroundColor={backgroundColor}>
      <Row width="100%" maxWidth={maxWidth}>
        <Col
          flexShrink={1}
          $platform-web={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
          }}
          columnGap="$0x"
          $largerThanXS={{ columnGap: '$8x' }}
          $largerThanSM={{
            columnGap: '$10x',
            ...(horizontalMargin && !mr ? { mr: '$20x' } : {}),
            ...(horizontalMargin && !ml ? { ml: '$20x' } : {}),
            ...(verticalMargin ? { my: '$20x' } : {}),
          }}
          $largerThanMD={{
            ...(horizontalMargin && !mr ? { mr: '$32x' } : {}),
            ...(horizontalMargin && !ml ? { ml: '$32x' } : {}),
            ...(verticalMargin ? { my: '$32x' } : {}),
          }}
          my={verticalMargin ? '$10x' : undefined}
          width="100%"
          mr={mr || (horizontalMargin ? '$10x' : undefined)}
          ml={ml || (horizontalMargin ? '$10x' : undefined)}
        >
          {children}
        </Col>
      </Row>
    </Row>
  );
}

export default Grid;
